// Lakai — site-wide header behavior (ported from 7kernel header.js,
// 2026-07-03 rebrand). Sticky reveal-on-scroll-up + mobile menu drawer with
// focus trap + cart-square coordination. The marquee above the header stays
// pinned; only the header hides on scroll-down.
//
// Public contract: window.P7Menu = { close() } (used by p7-cart.js so the two
// drawers never stack).
(function () {
  'use strict';
  if (window.__p7HeaderInit) return;
  window.__p7HeaderInit = true;

  var header = document.querySelector('[data-p7-header]');
  if (!header) return;

  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Sticky reveal-on-scroll-up ---------------- */
  var lastY = window.scrollY || 0;
  var hidden = false;
  var drawerOpen = false;
  var ticking = false;
  var DELTA = 6;

  function applyReveal() {
    root.classList.toggle('p7-nav-up', hidden);
  }

  function update() {
    var y = window.scrollY || 0;
    header.classList.toggle('is-stuck', y > 4);
    if (drawerOpen || y <= header.offsetHeight * 2) {
      if (hidden) { hidden = false; applyReveal(); }
    } else if (y > lastY + DELTA && !hidden) {
      hidden = true; applyReveal();
    } else if (y < lastY - DELTA && hidden) {
      hidden = false; applyReveal();
    }
    lastY = y;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; update(); });
    }
  }, { passive: true });
  window.addEventListener('resize', function () { if (hidden) applyReveal(); }, { passive: true });
  applyReveal();
  update();

  /* ---------------- Menu drawer ---------------- */
  var drawer = document.querySelector('[data-p7-mnav]');
  var burger = document.querySelector('[data-p7-mnav-open]');
  var panel = drawer ? drawer.querySelector('.p7-mnav__panel') : null;
  var closeEls = drawer ? drawer.querySelectorAll('[data-p7-mnav-close]') : [];
  var lastFocus = null;

  // The header wrapper is transformed by the reveal animation, which would trap
  // a position:fixed child — relocate the drawer to <body>.
  if (drawer && drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  function focusables() {
    return panel ? Array.prototype.slice.call(
      panel.querySelectorAll('a[href], button:not([disabled])')
    ) : [];
  }

  function openDrawer() {
    if (!drawer) return;
    if (window.P7Cart && window.P7Cart.close) window.P7Cart.close();
    lastFocus = document.activeElement;
    drawer.hidden = false;
    void drawer.offsetWidth; // reflow so the transition runs from hidden
    drawer.classList.add('is-open');
    root.classList.add('p7-no-scroll');
    drawerOpen = true;
    if (hidden) { hidden = false; applyReveal(); }
    if (burger) burger.setAttribute('aria-expanded', 'true');
    var f = focusables();
    if (f.length) f[0].focus();
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    root.classList.remove('p7-no-scroll');
    drawerOpen = false;
    if (burger) burger.setAttribute('aria-expanded', 'false');
    var done = function () {
      drawer.hidden = true;
      drawer.removeEventListener('transitionend', done);
    };
    if (reduceMotion) { done(); }
    else { drawer.addEventListener('transitionend', done); }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (burger) burger.addEventListener('click', openDrawer);
  Array.prototype.forEach.call(closeEls, function (el) {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (!drawerOpen) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- Search panel ----------------
     The header used to carry an always-open input, which at mobile widths was
     squeezed to ~110px between the logo and the icons. It is now a magnifying
     glass that reveals a full-width panel below the bar. */
  var searchPanel = document.querySelector('[data-p7-search-panel]');
  var searchOpen = document.querySelector('[data-p7-search-open]');
  var searchClose = document.querySelector('[data-p7-search-close]');
  var searchInput = searchPanel ? searchPanel.querySelector('[data-p7-search-input]') : null;

  function openSearch() {
    if (!searchPanel) return;
    searchPanel.hidden = false;
    if (searchOpen) searchOpen.setAttribute('aria-expanded', 'true');
    // The header hides on scroll-down; an open panel must not scroll away.
    if (hidden) { hidden = false; applyReveal(); }
    if (searchInput) searchInput.focus();
  }

  function closeSearch() {
    if (!searchPanel || searchPanel.hidden) return;
    searchPanel.hidden = true;
    if (searchOpen) {
      searchOpen.setAttribute('aria-expanded', 'false');
      searchOpen.focus();
    }
  }

  if (searchOpen) {
    searchOpen.addEventListener('click', function () {
      if (searchPanel && searchPanel.hidden) openSearch();
      else closeSearch();
    });
  }
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchPanel && !searchPanel.hidden) closeSearch();
  });

  // Clicking away closes it. Ignore clicks inside the panel or on the toggle,
  // otherwise opening it would immediately close it again.
  document.addEventListener('click', function (e) {
    if (!searchPanel || searchPanel.hidden) return;
    if (searchPanel.contains(e.target)) return;
    if (searchOpen && searchOpen.contains(e.target)) return;
    closeSearch();
  });

  /* ---------------- Colour scheme toggle ----------------
     Two-segment Light / Dark control (p7-scheme-toggle.liquid). Preference
     lives in localStorage 'p7-theme' ('dark' | 'light'; absent = follow the
     OS). A no-flash inline script in the layout <head> stamps data-theme on
     <html> before CSS loads; this block owns the clicks and keeps every
     instance (desktop nav + mobile drawer) in sync.

     There is no "system" segment to click back to — following the OS is just
     the state before the first tap. The fill on the active segment is CSS's
     job (it can read the OS query directly, so it is right on first paint);
     what this block maintains is aria-pressed, which CSS cannot set. */
  var schemeOptions = document.querySelectorAll('[data-p7-scheme-mode]');
  if (schemeOptions.length) {
    var SCHEME_KEY = 'p7-theme';
    var darkQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

    // The scheme actually on screen: the stored override, else whatever the
    // OS is currently asking for.
    var activeScheme = function () {
      var stored = null;
      try { stored = window.localStorage.getItem(SCHEME_KEY); } catch (e) {}
      if (stored === 'dark' || stored === 'light') return stored;
      return darkQuery && darkQuery.matches ? 'dark' : 'light';
    };

    var syncPressed = function () {
      var active = activeScheme();
      Array.prototype.forEach.call(schemeOptions, function (btn) {
        var on = btn.getAttribute('data-p7-scheme-mode') === active;
        btn.setAttribute('aria-pressed', String(on));
      });
    };

    var applyScheme = function (mode) {
      root.setAttribute('data-theme', mode);
      try { window.localStorage.setItem(SCHEME_KEY, mode); } catch (e) {}
      syncPressed();
    };

    Array.prototype.forEach.call(schemeOptions, function (btn) {
      btn.addEventListener('click', function () {
        applyScheme(btn.getAttribute('data-p7-scheme-mode'));
      });
    });

    // Until the shopper taps, the control tracks the OS live — matching what
    // the CSS is already doing on its own.
    if (darkQuery && darkQuery.addEventListener) {
      darkQuery.addEventListener('change', syncPressed);
    }

    // Both buttons render aria-pressed="false" (Liquid cannot know the OS
    // scheme); mark the real one now.
    syncPressed();
  }

  window.P7Menu = { close: closeDrawer };
})();
